// src/PrivateRoute.js
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ element, roles, userName }) => {
  const token = localStorage.getItem("token");
  const userRole = localStorage.getItem("role");

  const [EUserName, setEUserName] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    setEUserName(storedUser);
  }, []);

  if (!token) return <Navigate to="/login" />;
  if (userName && !userName.includes(EUserName)) {
    return <Navigate to="/login" />;
  }
  if (roles && !roles.includes(userRole)) {
    return <Navigate to="/login" />;
  }
  return element;
};

PrivateRoute.propTypes = {
  element: PropTypes.node.isRequired,
  roles: PropTypes.array,
  userName: PropTypes.array
};

export default PrivateRoute;
